import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { formatToline1 } from "@/utils/utils";
export default {
  name: 'maptype',
  props: ['typedata', 'elemName', 'jsonOption', 'currentType', 'typemodel', 'ispc'],
  components: {},
  meta: {
    title: ''
  },
  data() {
    return {
      fid: this.$route.query.fid,
      showorhide: false,
      isupdate: false,
      linormal: {},
      lifocus: {},
      currentTypeTitle: '全部'
    };
  },
  watch: {
    jsonOption: {
      deep: true,
      // 深度监听
      handler(newVal, oldVal) {
        //回调
        console.log(newVal);
        if (newVal.typenav) this.isupdate = true;
        if (newVal.typenav && newVal.typenav.othernormalform) {
          let normal = newVal.typenav.othernormalform;
          Object.keys(normal).forEach(elem => {
            if (elem === 'height') {
              this.linormal.height = normal[elem] + 'px';
              this.linormal.lineHeight = normal[elem] + 'px';
            } else if (elem === 'fontSize') {
              this.linormal[elem] = normal[elem] + 'px';
            } else if (elem === 'backgroundfile' && normal[elem].length === 0) {
              this.linormal.backgroundImage = 'none';
            } else {
              this.linormal[elem] = normal[elem];
            }
          });
          // delete this.linormal.backgroundfile
        }
        if (newVal.typenav && newVal.typenav.otherfocusform) {
          let focus = newVal.typenav.otherfocusform;
          Object.keys(focus).forEach(elem => {
            if (elem === 'height') {
              this.lifocus.height = focus[elem] + 'px';
              this.lifocus.lineHeight = focus[elem] + 'px';
            } else if (elem === 'fontSize') {
              this.lifocus[elem] = focus[elem] + 'px';
            } else if (elem === 'backgroundfile' && focus[elem].length === 0) {
              this.lifocus.backgroundImage = 'none';
            } else {
              this.lifocus[elem] = focus[elem];
            }
          });
          // delete this.lifocus.backgroundfile
        }
        // console.log(this.linormal)
        // console.log(this.lifocus)
      }
    }
  },
  methods: {
    styleHandle() {
      this.$emit('stypeClick', 'typenav');
    },
    typeselect(item, index) {
      if (parseInt(this.typemodel) !== 5) this.showorhide = false;
      this.currentTypeTitle = item.value;
      this.$emit('typeclick', {
        index: index,
        item: item
      });
    },
    btnHandle() {
      this.showorhide = !this.showorhide;
    }
  }
};